export default "__VITE_ASSET__ff0d2994__"